import BaseModule from '../BaseModule.js';
import { Constants } from '../Constants.js';
import CalendarDayHelper from './CalendarDayHelper.js';

export default {
	mixins: [BaseModule, CalendarDayHelper],
	methods: {
		buildHTML(props) {
			this.setup(props);
			return this.getHTML(props);
		},
		setup(props) {
			props.isDisabled = false;
			props.isCheckinDisabled = false;
			props.isCalendarVisible = false;
			props.isVacation = false;
			props.vac = null;
			props.colors = [];
			props.tips = [];
			props.tooltip = null;
			props.hasTooltip = false;
			props.projectsTextAndColor = [];

			props.isDisabled = this.checkDisabled(props);

			// Si el trabajador no trabaja en la empresa, no continuamos
			if (props.isDisabled) {
				return;
			}

			props.calendar = props.calendars.find(c => c.id === props.data.calendarId);

			// Comprobamos si hay vacaciones
			this.checkVacation(props);

			props.isCheckinDisabled = this.checkCheckinDisabled(props);

			// Si el check-in no está habilitado, no continuamos
			if (props.isCheckinDisabled) {
				return;
			}

			// Si no hay vacaciones, comprobamos si es festivo o descanso
			if (!props.isVacation) {
				this.checkHolidayOrRest(props);
			}

			// Comprobamos si hay que mostrar el calendario
			if (props.calendar) {
				props.isCalendarVisible = this.checkIfCalendarIsVisible(props.calendar.id);
			} else {
				props.isCalendarVisible = false;
			}

			if (props.type === Constants.MONTHLYDAY_TYPE) {
				this.checkMonthlyProjects(props);
			} else if (props.type === Constants.WEEKLYDAY_TYPE) {
				this.checkWeeklyProjects(props);
			}
		},
		checkVacation(props) {
			for (let i = 0; i < props.vacation.length; i++) {
				const vac = props.vacation[i];
				
				if (this.compareSimpleDates(props.data.simpleCalendarDay, vac.fromDate) >= 0 
					&& this.compareSimpleDates(props.data.simpleCalendarDay, vac.toDate) <= 0) {			

					props.vac = vac;
					
					props.tips.push(props.vac.recordTitle);
			
					props.hasTooltip = props.tooltip || props.tips.length > 0;

					const type = this.getVacationLegendType(props.vac.recordStatus, props.vac.hoursBagType);

					props.isVacation = this.getVacationFilterType(type, props.colors);
				}

				if (props.isVacation) {
					break;
				}
			}
		},
		checkHolidayOrRest(props) {
			this.getHolidayOrRest(props.data.dayType, props.data.notes, props.colors, props.tips);
			props.hasTooltip = props.tooltip || props.tips.length > 0;
		},
		checkDisabled(props) {			
			let dt = props.employee.dateDismissalCompany ? new Date(props.employee.dateDismissalCompany) : new Date(3000, 1, 1);
			const dismissalDate = this.addDaysToDate(dt, 1).getTime();
			
			const employeeDateRegistrationCompany = props.employee.dateRegistrationCompany;
			const employeeCreationSimpleDate = this.convertDateToSimpleDate(new Date(props.employee.creationDate));
			const simpleCalendarDay = props.data.simpleCalendarDay;
			const employeeCreationDateIsAfterThanCalendarDay = this.compareSimpleDates(employeeCreationSimpleDate, simpleCalendarDay) > 0;
			const employeeDateRegistrationCompanyIsAfterThanCalendarDay = (employeeDateRegistrationCompany !== null && employeeDateRegistrationCompany > props.data.calendarDay);
			const dismissalDateIsBeforeThanCalendarDay = dismissalDate < props.data.calendarDay;

			/*console.log(`*** simpleCalendarDay: ${JSON.stringify(this.data.simpleCalendarDay)}`);
			console.log(`*** employeeCreationSimpleDate: ${JSON.stringify(employeeCreationSimpleDate)}`);
			console.log(`*** employeeCreationDateIsAfterThanCalendarDay: ${employeeCreationDateIsAfterThanCalendarDay}`);
			console.log(`*** employeeDateRegistrationCompany: ${employeeDateRegistrationCompany}`);
			console.log(`*** this.data.calendarDay: ${this.data.calendarDay}`);
			console.log(`*** employeeDateRegistrationCompanyIsAfterThanCalendarDay: ${employeeDateRegistrationCompanyIsAfterThanCalendarDay}`);
			console.log(`*** dismissalDate: ${dismissalDate}`);
			console.log(`*** dismissalDateIsBeforeThanCalendarDay: ${dismissalDateIsBeforeThanCalendarDay}`);
			console.log(`*** isEmployeeCheckinEnabled: ${this.data.isEmployeeCheckinEnabled}`);*/
			
			const condition1 = (employeeDateRegistrationCompany === null && employeeCreationDateIsAfterThanCalendarDay);
			const condition2 = employeeDateRegistrationCompanyIsAfterThanCalendarDay;
			const condition3 = dismissalDateIsBeforeThanCalendarDay;
			
			/*console.log(`*** condition1: ${condition1}`);
			console.log(`*** condition2: ${condition2}`);
			console.log(`*** condition3: ${condition3}`);*/

			const result = condition1 || condition2 || condition3;
			
			return result;
		},
		checkCheckinDisabled(props) {
			const result = props.data.isEmployeeCheckinEnabled !== null && props.data.isEmployeeCheckinEnabled === false;

			if (result && !props.isVacation) {
				props.colors.push('#f5f5f5');
			}

			return result;
		},
		buildSummaryHtml(props) {
			return this.buildHTMLSummary(this.calculateSummary(props.data));			
		},
		checkMonthlyProjects(props) {
			this.getMonthlyProjects(props, (colors, tips) => {
				props.colors = [...props.colors, ...colors];
				props.tips = [...props.tips, ...tips];
				
				props.hasTooltip = props.tooltip || props.tips.length > 0;
			});
		},
		checkWeeklyProjects(props) {
			this.getWeeklyProjects(props, (textAndColor, tips) => {
				props.projectsTextAndColor = textAndColor;
				props.tips = [...props.tips, ...tips];
				
				props.hasTooltip = props.tooltip || props.tips.length > 0;
			});
		},
	}
}